import { Injectable, computed, signal } from '@angular/core';

import {
  DEFAULT_ROUTE_SCROLL_MODE,
  RouteScrollMode,
} from './route-scroll-mode.models';

interface RouteScrollModeRegistration {
  id: number;
  mode: RouteScrollMode;
}

@Injectable({ providedIn: 'root' })
export class RouteScrollModeRuntime {
  private nextRegistrationId = 0;
  private readonly registrations = signal<RouteScrollModeRegistration[]>([]);

  readonly activeMode = computed<RouteScrollMode>(() => {
    const registrations = this.registrations();
    return registrations.at(-1)?.mode ?? DEFAULT_ROUTE_SCROLL_MODE;
  });

  register(mode: RouteScrollMode): () => void {
    const id = this.nextRegistrationId++;
    this.registrations.update((currentRegistrations) => [
      ...currentRegistrations,
      { id, mode },
    ]);

    return () => {
      this.registrations.update((currentRegistrations) =>
        currentRegistrations.filter((registration) => registration.id !== id),
      );
    };
  }
}
